import { ApiBind, Common } from './common.model';
import { SDKVersionGroupSDKVersion } from './sdk-version-group-sdk-version.model';

export class SDKVersionGroup extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'white_list', model: (values) => values.map(v => new SDKVersionGroupSDKVersion(v)) })
  whiteList: SDKVersionGroupSDKVersion[];

  @ApiBind({ column: 'black_list', model: (values) => values.map(v => new SDKVersionGroupSDKVersion(v)) })
  blackList: SDKVersionGroupSDKVersion[];

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

  public toDeleteItemJSON() {
    return { id: this.convertJSONObject(this.id), updated_at: this.convertJSONObject(this.updatedAt) };
  }
}
